import { createFileRoute, useParams } from '@tanstack/react-router';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import { DashboardRoute } from '@/pages/workspaces/dashboard/routing';
import { LastWorkspaceResolver } from './-route-helpers';
import { ClassicDashboardPage } from './-route-pages';

/**
 * The migrated URL, without the `journeys` segment (FPS-2301).
 *
 * No `appBundle`: the bundle-aware branch of the resolver rebuilds the target from the bundle
 * prefix, which would find no `/journeys/` here and land on the journeys home instead.
 *
 * The page is keyed on the workspace so a switch starts it over rather than carrying the
 * previous workspace's reading across.
 */
function ClassicDashboardRoute() {
  const { workspaceId } = useParams({ from: '/_authenticated/workspaces/$workspaceId/dashboard' });

  return (
    <LastWorkspaceResolver>
      <DashboardRoute>
        <RumPageRendered>
          <ClassicDashboardPage key={workspaceId} />
        </RumPageRendered>
      </DashboardRoute>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/dashboard')({
  component: ClassicDashboardRoute,
});
